'use strict'

const service = config.VUE_APP_service_licenze || ''

// ********************************   Versione MongoDb ***********************************
async function getInfoSetup() {
  try {
    const response = await fetch(`${service}/configs/setup`, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return await response.json()
  } catch (error) {
    return []
  }
}

async function getAllInfo(separaInfo) {
  try {
    const response = await fetch(`${service}/configs/all${separaInfo ? '?separainfo=true' : ''}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return await response.json()
  } catch (error) {
    return []
  }
}

async function aggiornaConfigurazione(configurazione) {
  try {
    const data = {
      configurazione
    }
    const response = await fetch(`${service}/configs/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return {}
  }
}

async function cancellaConfigurazione(configurazioneId) {
  try {
    const data = {
      configurazioneId
    }
    const response = await fetch(`${service}/configs/delete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return {}
  }
}

// ***************************************************************************************

async function leggeFileImpostazione(pathId) {
  try {
    const response = await fetch(`${service}/configs/singola?pathId=${pathId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return await response.json()
  } catch (error) {
    // errorService.onError(error, 'getRivenditori')
    return []
  }
}

async function leggeAlberoImpostazioni() {
  try {
    const response = await fetch(`${service}/configs`, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return await response.json()
  } catch (error) {
    // errorService.onError(error, 'getRivenditori')
    return []
  }
}

async function aggiornaPrerequisiti(codiceCliente, prerequisiti) {
  try {
    const data = {
      codiceCliente,
      prerequisiti
    }
    const response = await fetch(`${service}/configs/prerequisiti`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return {}
  }
}

async function aggiornaConfigurazioneBase(codiceCliente, stato) {
  try {
    const data = {
      codiceCliente: codiceCliente,
      configurazioneLetta: stato
    }
    const response = await fetch(`${service}/configs/base`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return {}
  }
}

// ********************************   Gestione Checklist  ***********************************
// Deve essere presa da Cloudant (per adesso)
async function getElencoChecklist() {
  try {
    const response = await fetch(`${service}/configs/checklist`, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return await response.json()
  } catch (error) {
    return []
  }
}

async function getChecklistCliente(codiceCliente, codiceChecklist) {
  try {
    const response = await fetch(`${service}/configs/checklist/${codiceCliente}/${codiceChecklist}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return await response.json()
  } catch (error) {
    return []
  }
}

async function setChecklistValue(codiceCliente, codiceChecklist, codiceItem, checked) {
  try {
    const data = {
      codiceCliente,
      codiceChecklist,
      codiceItem,
      checked
    }    
    const response = await fetch(`${service}/configs/checklist`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    return []
  }
}

export default {
  getInfoSetup,
  getAllInfo,
  aggiornaConfigurazione,
  cancellaConfigurazione,

  leggeFileImpostazione,
  leggeAlberoImpostazioni,
  aggiornaPrerequisiti,
  aggiornaConfigurazioneBase,
  getElencoChecklist,
  getChecklistCliente,
  setChecklistValue
}
